import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { filter } from 'rxjs';

import {
  NavigationEnd,
  NavigationStart,
  Router
} from '@angular/router';

import { Location } from '@angular/common';

import { ViewManagerService } from './view-manager.service';
import { AuthService } from '../auth.service';
import { StatisticsService } from '../statistics.service';

type ActivitySource =
  | 'scroll'
  | 'mousemove'
  | 'click'
  | 'media'
  | 'navigation'
  | 'visibility';

@Injectable({ providedIn: 'root' })
export class ActivityManagerService {
  private isActive: boolean = false;

  // Timestamp ISO string
  private timestamp: string | null = null;

  private initialized: boolean = false;

  private lastMarkActive: number = 0;
  private pingInterval: any;
  private pingIntervalAccumulative: number = 0;

  private readonly MARK_ACTIVE_COOLDOWN = 5000; // 5 segundos

  private footerElement: HTMLElement | null = null;

  constructor(
    private viewManager: ViewManagerService,
    private stats: StatisticsService,
    private router: Router,
    private auth: AuthService,
    private location: Location
  ) { }

  // ------------- init ----------------

  public async loadAcitvityManager(): Promise<void> {
    const sitevisitTimeStamp: string | null = await this.viewManager.loadViewManager();

    if (this.initialized) {
      this.timestamp = sitevisitTimeStamp;
      return;
    }

    this.init(sitevisitTimeStamp);
  }

  private init(siteVisitTimestamp: string | null): void {
    this.initialized = true;

    this.timestamp = siteVisitTimestamp;

    this.handleNavigationChanges();
    this.schedulePing();

    setInterval(() => {
      this.registerActivity('visibility', {
        force: true,
        reopenCurrentPage: true
      }).catch(console.error);
    }, 20000);
    // (['scroll', 'mousemove', 'click'] as const).forEach((evt) => {
    //   window.addEventListener(evt, () => this.markActive(evt));
    // });

    // window.addEventListener('focus', () => {
    //   this.registerActivity('visibility', {
    //     force: true,
    //     reopenCurrentPage: true
    //   }).catch(console.error);
    // });

    // document.addEventListener('visibilitychange', () => {
    //   if (document.hidden) return;

    //   this.registerActivity('visibility', {
    //     force: true,
    //     reopenCurrentPage: true
    //   }).catch(console.error);
    // });
  }

  // ------------- getter & setters ----------------

  private shouldPing(): boolean {
    return this.isActive;
  }

  private resetActivity(): void {
    this.isActive = false;
  }

  public getLastActivity(): string {
    return this.timestamp ?? '';
  }

  // ------------- Subscribe & listen to navigation changes ----------------

  private handleNavigationChanges(): void {
   
  }

  // ------------- Update sitevisit timestamp on activity ----------------

  public markActive(eventType: ActivitySource): void {
    this.registerActivity(eventType, {
      force: false,
      reopenCurrentPage: true
    }).catch(console.error);
  }

  private async registerActivity(
    eventType: ActivitySource,
    options: {
      force: boolean;
      reopenCurrentPage: boolean;
    }
  ): Promise<void> {
    this.reviewPageScroll(eventType);

    const now = Date.now();

    if (!options.force && now - this.lastMarkActive < this.MARK_ACTIVE_COOLDOWN) {
      return;
    }

    this.lastMarkActive = now;

    const recreatedTimestamp = await this.viewManager.ensureValidSiteVisit(
      options.reopenCurrentPage
    );

    if (recreatedTimestamp) {
      this.timestamp = recreatedTimestamp;
    }

    const timezone =
      DateTime.local().zoneName;

    const timestamp = DateTime.now()
      .setZone(timezone)
      .toISO() ?? '';

    this.timestamp = timestamp;
    this.isActive = true;


    this.viewManager.refreshSiteVisitTimestamp(timestamp);
    this.stats.timestamp = timestamp
  }

  // ------------- review page scroll ----------------

  private reviewPageScroll(eventType: ActivitySource): void {
    if (eventType !== 'scroll') return;

    if (!this.footerElement) {
      this.footerElement = document.querySelector('footer');
    }

    if (!this.footerElement) return;

    const footerTop = this.footerElement.getBoundingClientRect().top - 500;
    const viewportHeight = window.innerHeight;

    if (footerTop <= viewportHeight) {
      this.viewManager.emitScroll();
    }
  }

  // ------------- Ping views every 20 sec ----------------

  private schedulePing(): void {
    this.pingInterval = setInterval(() => {
      this.pingIntervalAccumulative += 20000;

      this.pingOpenedViews();

      // Si quieres reactivar validación de token cada 5 min:
      // this.checkTokenExpiration();
    }, 20000);
  }

  private clearPing(): void {
    if (!this.pingInterval) return;

    clearInterval(this.pingInterval);
    this.pingInterval = null;
  }

  private pingOpenedViews(): void {
    if (!this.shouldPing()) return;

    this.viewManager.emitPing();
    this.resetActivity();
  }

  // ------------- Check token expiration every 5 min ----------------

  private checkTokenExpiration(): void {
    if (!this.shouldPing()) return;
    if (this.pingIntervalAccumulative < 300000) return;

    this.pingIntervalAccumulative = 0;

  }

  // ---------------- replace correct url client name ----------------


  public externalClearPing(): void {
    this.clearPing();
  }
}